.group { display: inline-flex; gap: 2px; padding: 3px; border-radius: var(--radius-full); background: var(--glass-hover); border: 1px solid var(--color-border); }
.segment {
  display: inline-flex; align-items: center; justify-content: center; gap: var(--space-1-5);
  min-height: 30px; padding: 0 14px; border: 0; border-radius: var(--radius-full);
  background: transparent; color: var(--color-text-secondary); font-size: var(--text-sm); font-weight: var(--weight-medium);
  transition: background-color var(--duration-fast) ease, color var(--duration-fast) ease, box-shadow var(--duration-fast) ease;
}
.segment svg { width: 16px; height: 16px; }
.segment:hover { color: var(--color-text); }
.checked { background: var(--color-surface); color: var(--color-text); box-shadow: var(--shadow-1); }
:root[data-theme="dark"] .checked { background: var(--color-surface-raised); box-shadow: 0 0 0 1px var(--color-border-strong); }
